import React from 'react';
import { Typography, useTheme } from '@mui/material';
import { CardItem } from '@europrocurement/flexy-components';
import { SignableDocumentRecipient } from '../../../../providers/types';

export type RecipientsCollectionProps = {
    recipients: Array<SignableDocumentRecipient>;
    onRemoveRecipient?: (recipient: SignableDocumentRecipient) => void;
};

const RecipientsCollection: React.FunctionComponent<RecipientsCollectionProps> = function (props) {
    const { recipients, onRemoveRecipient } = props;
    const { palette } = useTheme();

    const handleRemove = (recipient: SignableDocumentRecipient) => {
        if (onRemoveRecipient) {
            onRemoveRecipient(recipient);
        }
    };

    return (
        <>
            <Typography variant="l2dh7">
                {recipients.length > 1 ? 'Destinataires' : 'Destinataire'}
            </Typography>
            {recipients.map((recipient) => {
                const infos = [recipient.email];

                if (recipient.mobile) {
                    infos.push(recipient.mobile);
                }

                return (
                    <CardItem
                        key={`${recipient.firstName}-${recipient.lastName}`}
                        title={`${recipient.firstName} ${recipient.lastName}`}
                        icon="user"
                        color={palette.primary}
                        additionalInfos={infos}
                        actions={[
                            {
                                label: 'Supprimer cet élément',
                                icon: 'trash-can',
                                onClick: () => handleRemove(recipient),
                            },
                        ]}
                    />
                );
            })}
        </>
    );
};

export default RecipientsCollection;
